import { updateItemInCollection } from "directus/src/operations";

export async function updateCaseStudyVideo({ item, caseStudyId }) {
    try {
        const query = {
            fields: [
                "id",
                "video",
            ],
        };

        const data = await updateItemInCollection(
            "case_studies",
            caseStudyId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
